const minHeight = typeof window !== 'undefined' && window.innerHeight
const minWidth = typeof window !== 'undefined' && window.innerWidth

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
    minWidth: minWidth / 2
  },
  attchmentRemoveButtons: {
    padding: 0,
    minWidth: 'initial',
  },
  block: {
    display: 'block'
  },
  modal: {
    maxWidth: minWidth / 1.5,
    minWidth: minWidth / 3
  },
  modalHeader: {
    fontWeight: '600!important',
    fontSize: '1.2rem!important',
  },
  button: {
    marginLeft: theme.spacing.unit * 2
  },
  error: {
    background: theme.palette.secondary.main,
    color: theme.palette.common.white,
    textAlign: 'center'
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622'
    }
  },
  close: {
    padding: 0,
    minWidth: 40,
  },
  form: {},
  attchmentRemoveButtons: {},
  buttonBase: {},
  handleLongString: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    position: 'relative',
    maxWidth: '500px'
  },
  upload: {
    '@supports ((-moz-appearance:none) or (-webkit-appearance:none))': {
      '& input': {
        height: '2em',
      },
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/jobandtestattachments/styles.js